import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 2rem;
`;

export const Title = styled.h1`
  margin-bottom: 2rem;
  font-family: Montserrat;
`;